import { __awaiter, __generator } from "tslib";
import { getFileTypeNameFromType } from '@office-start/file-utility';
import { launchTemplate } from '@office-start/launcher-service';
export function launchTemplateWrapper(app, templateUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var appName, launchResult, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!app || !templateUrl) {
                        Promise.resolve("Error" /* CreateDocumentResultType.Error */);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    appName = getFileTypeNameFromType(app);
                    return [4 /*yield*/, launchTemplate(appName, templateUrl)];
                case 2:
                    launchResult = _a.sent();
                    if (!launchResult) {
                        throw new Error("Failed to launch newly created ".concat(appName, " file with template."));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _error_1 = _a.sent();
                    // TODO: logging if needed
                    return [2 /*return*/, Promise.resolve({
                            type: "OpenNewDocFailed" /* CreateDocumentResultType.OpenNewDocFailed */,
                        })];
                case 4: return [2 /*return*/, Promise.resolve({ type: "GoToBlankDoc" /* CreateDocumentResultType.GoToBlankDoc */ })];
            }
        });
    });
}
//# sourceMappingURL=launchTemplateWrapper.js.map